import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import env from '@beam-australia/react-env';
import urls, { endpoints } from '@/constants/urls';

export const baseHTMLTags = {
  p: (chunks) => <p>{chunks}</p>,
  strong: (chunks) => <strong>{chunks}</strong>,
  b: (chunks) => <b>{chunks}</b>,
  i: (chunks) => <i>{chunks}</i>,
  code: (chunks) => <code>{chunks}</code>,
  br: () => <br />, // https://github.com/formatjs/formatjs/issues/1545
};

export const customLinks = ({ email }) => ({
  workspacesLink: (chunks) => (
    <a
      rel="noopener noreferrer"
      target="workspaces"
      href={env('PRIMARY_WORKSPACES_HUB_URL')}
    >
      {chunks}
    </a>
  ),
  documentationLink: (chunks) => (
    <a rel="noopener noreferrer" target="api" href={endpoints.DOCS}>
      {chunks}
    </a>
  ),
  searchHelpLink: (chunks) => (
    <a rel="noopener noreferrer" target="_blank" href={urls.SEARCH_HELP}>
      {chunks}
    </a>
  ),
  primaryDictionaryReferenceLink: (chunks) => (
    <a
      rel="noopener noreferrer"
      target="_blank"
      href={`${urls.KB_EDIT_DICTIONARY}#setting-a-primary-dictionary`}
    >
      {chunks}
    </a>
  ),
  serviceDeskLink: (chunks) => (
    <a rel="noopener noreferrer" target="_blank" href={urls.SERVICE_DESK}>
      {chunks}
    </a>
  ),
  mailToLink: (chunks) => (
    <a href={`mailto:${email}`} rel="noopener noreferrer">
      {chunks}
    </a>
  ),
});

const FormattedHTMLMessage = ({ id, values }) => {
  const finalValues = useMemo(
    () => ({
      ...baseHTMLTags,
      ...customLinks(values || {}),
      ...values,
    }),
    [values],
  );

  return <FormattedMessage id={id} values={finalValues} />;
};

export default FormattedHTMLMessage;
